<template>
  <SectionLayout :section-title="sectionTitle" custom-class="p-2" section-key="blog" :loading="loadingDashboard">
    <template #headerAction>
      <a href="https://gempages.net/blogs/shopify" target="_blank" class="d-flex align-items-center dashboard__link">
        <!-- Read More -->
        <span class="paragraph-14-16-medium dashboard__link-txt">{{ viewMore }}</span>
        <div class="dashboard__link-icon d-flex align-items-center">
          <i class="icon icon-link"></i>
        </div>
      </a>
    </template>
    <template>
      <template  v-for="(blog, index) in blogs">
        <a class="clickable dashboard__blog" target="_blank" v-if="blog" :class="getItemDynamicClass(index)" :key="index" :href="blog.action">
          <img class="dashboard__blog-img" :src="blog.img" :alt="blog.title" />
          <p class="dashboard__blog-title">{{ blog.title }}</p>
        </a>
        <div class="clickable dashboard__blog mt-2" v-else :key="index">
          <div class="dashboard__blog-img skeleton-light-grey-200"></div>
          <p class="dashboard__blog-title skeleton-light-grey-200"></p>
        </div>
      </template>
    </template>
  </SectionLayout>
</template>

<script>
import SectionLayout from "./SectionLayout.vue";
import ActionMixin from "./ActionMixin";
import { mapGetters } from "vuex";

export default {
  name: "Blog",
  components: {
    SectionLayout
  },
  mixins: [ActionMixin],
  data: () => ({
    linkIconSrc: require("@/core/assets/new-dashboard/link.svg")
  }),
  computed: {
    ...mapGetters("account", {
      lang: "displayLanguage"
    }),
    ...mapGetters("dashboard", {
      blogData: "blog",
      loadingDashboard: "loading"
    }),
    sectionTitle() {
      return this.$t("dashboard.blog");
    },
    viewMore() {
      return this.$t("dashboard.viewMore");
    },
    blogs() {
      if (this.loadingDashboard) {
        return [null, null, null, null];
      }
      const length = this.blogData.length;
      const defaultLang = "en";
      const blogList = [];
      
      for (let i = 0; i < length; i++) {
        const data = this.blogData[i];
        const img = !data.img[this.lang] ? data.img[defaultLang] : data.img[this.lang];
        const title =  !data.title[this.lang] ? data.title[defaultLang] : data.title[this.lang];
        const action =  !data.action[this.lang] ? data.action[defaultLang] : data.action[this.lang];
        blogList.push({ img, action, title });
      }

      return blogList
    }
  },
  methods: {
    getItemDynamicClass(index) {
      return {
        "mt-2": index > 0
      };
    }
  }
};
</script>

<style lang="scss">
.dashboard {
  &__blog {
    display: flex;
    border: solid 1px map-get($hybrid-shade-light, '400');
    border-radius: 3px;
    background: map-get($hybrid-shade-light, '100');
    &-img {
      width: 112px;
      height: 61px;
      display: flex;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &-title {
      flex: 1;
      padding: 0 16px 0 12px;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 150%;
      color: map-get($text-light-mode, 'high-contrast');
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin: 11px 0;
      &.skeleton-light-grey-200 {
        padding: 0;
        margin: 11px 12px;
        height: 16px;
      }
    }
    &:hover {
      border: solid 1px map-get($hybrid-shade-dark, '100');
    }
  }
}
.blog {
  &__loading {
    &-short {
      width: 60px;
      height: 16px;
    }

    &-long {
      width: 100%;
      height: 16px;
    }
  }
}
</style>
